import { styled } from '@mui/material';
import { colorPalettes } from '../../context/theme';

export const StyledIcon = styled('i')`
  color: ${({ theme, color }) =>
    color ?? colorPalettes[theme.palette.mode].text.primary};
  display: flex;
`;
